
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';

export default ComponentInitializeDispatcher.extend({
  name: 'owc-validation-box-wrapper',
  components: {
    SlotContainer,
  },
});
